import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import {
  postMultipleKambiSharesToBetLoop,
  postShareToBetLoop,
} from '@core/Areas/BetLoop/helpers/api'

export const postSharedBetToBetLoop = async ({
  ticketSequence = undefined,
  coupon = undefined,
}: PostSharedBetArgs): Promise<{
  postId: number
  betsShared?: number
}> => {
  if (ticketSequence) {
    return postShareToBetLoop({ ticketSequence })
  }

  if (coupon) {
    if (!coupon) {
      throw new Error('Kambi: Unable to get Kambi coupon for share')
    }

    const bets = coupon.bets.map(({ betRef }) => ({ couponRef: coupon.couponRef, betRef }))
    const response = await postMultipleKambiSharesToBetLoop({ bets })

    if (response.successfulShares === 0) {
      throw Error('Unable to share bets to Bet Loop')
    }

    const successfulShares = response.results.filter(result => result.success)
    return {
      postId: successfulShares[0].postId,
      betsShared: response.successfulShares,
    }
  }

  throw new Error('No bet ID provided for share')
}

// =====
// Types
// =====

type PostSharedBetArgs =
  | { ticketSequence: number; coupon?: undefined }
  | {
      coupon: KambiHistoryCoupon
      ticketSequence?: undefined
    }
